var _style, _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabricsSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40.1 42",
    style: {
      enableBackground: "new 0 0 40.1 42"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#FF3621;}\n ")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 42,
    width: 40.1,
    x: -69.1,
    y: -10.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.1,31.1v-7.4l-0.8-0.5L20.1,33.7l-18.2-10l0-4.3l18.2,9.9l20.1-10.9v-7.3l-0.8-0.5L20.1,21.2L2.6,11.6 L20.1,2l14.1,7.7l1.1-0.6V8.3L20.1,0L0,10.9V12L20.1,23l18.2-10v4.4l-18.2,10L0.8,16.8L0,17.3v7.4l20.1,10.9l18.2-9.9v4.3l-18.2,10 L0.8,29.5L0,30v1.1L20.1,42L40.1,31.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabricsSymbol);
export default __webpack_public_path__ + "static/media/databrics-symbol.d2852e3778e974f7898ad27f4d2e61f8.svg";
export { ForwardRef as ReactComponent };